import { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import StatCard from "@/components/StatCard";
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";
import { Activity, Clock, CheckCircle2 } from "lucide-react";

export default function Productivity() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/dashboard/stats").then((r) => setStats(r.data)); }, []);
  if (!stats) return <div className="p-10 text-slate-500">Loading…</div>;

  return (
    <div className="p-6 md:p-10 max-w-6xl mx-auto" data-testid="productivity-page">
      <PageHeader title="My Productivity" subtitle="Throughput over the last 7 days." />
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-6">
        <StatCard label="Coded Today" value={stats.coded_today} icon={Activity} testId="prod-today"/>
        <StatCard label="QA Pending" value={stats.qa_pending} accent="text-amber-600" icon={Clock} testId="prod-pending"/>
        <StatCard label="QA Completed" value={stats.qa_completed} accent="text-emerald-600" icon={CheckCircle2} testId="prod-completed"/>
      </div>

      <div className="bg-white border border-slate-200 rounded-xl p-5">
        <h3 className="font-heading text-lg font-medium text-slate-900 mb-4">Daily charts submitted</h3>
        <div className="h-72">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={stats.productivity_series}>
              <defs>
                <linearGradient id="prodFill" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#0369A1" stopOpacity={0.3}/>
                  <stop offset="100%" stopColor="#0369A1" stopOpacity={0}/>
                </linearGradient>
              </defs>
              <CartesianGrid stroke="#E2E8F0" strokeDasharray="3 3" vertical={false}/>
              <XAxis dataKey="day" tick={{ fontSize: 12, fill: "#64748B" }} />
              <YAxis tick={{ fontSize: 12, fill: "#64748B" }} allowDecimals={false}/>
              <Tooltip />
              <Area type="monotone" dataKey="count" stroke="#0369A1" fill="url(#prodFill)" strokeWidth={2.5}/>
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
